<template>
  <div>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon>mdi-view-list </v-icon>
      <v-toolbar-title>Account No. Suffix Mapping </v-toolbar-title>
    </v-toolbar>
    <v-flex xs12>
      <message :messages="messages"></message>
    </v-flex>
    <v-flex>
      <v-card>
        <v-flex xs12>
          <form action="">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex md6>
                            <v-autocomplete
                              :label="labels.directRi"
                              :items="directRiList"
                              v-model="filters.directRi"
                              item-text="value"
                              item-value="code"
                              data-vv-name="directRi"
                              :data-vv-as="labels.directRi"
                              :error-messages="errors.collect('directRi')"
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class=" mr-2" @click="doNew">
            New Account No. Suffix Mapping
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ getApplnInt(row.item.acctNoSfxApplnInt) }}</td>
                  <td class="text-xs-left">{{ row.item.acctNoSfx }}</td>
                  <td class="text-xs-left">{{ row.item.directRiDesc }}</td>
                  <td class="table-action-header">
                    <table-action :rowData="row" query @query="doQuery(row.item)" remove @remove="doDelete(row.item)"></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <v-dialog v-model="mapDialog" width="800px" persistent>
        <v-card>
          <v-toolbar v-if="newMap" dense color="grey lighten-3" flat>
            <v-icon>mdi-plus </v-icon>
            <v-toolbar-title>Create New Account No. Suffix Mapping </v-toolbar-title>
          </v-toolbar>
          <v-toolbar v-if="!newMap" dense color="grey lighten-3" flat>
            <v-icon>mdi-magnify </v-icon>
            <v-toolbar-title>View Account No. Suffix Mapping </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
            <v-container grid-list-md>
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.acctNoSfx }}</v-subheader>
                  <div class="queryValue">{{ acctNoSfxMapForm.acctNoSfx }}</div>
                </v-flex>
              </v-layout>
              <template v-if="newMap">
                <v-layout row>
                  <v-flex xs6>
                    <v-autocomplete
                      :label="labels.acctNoSfxApplnInt"
                      :items="applnIntList"
                      item-text="label"
                      item-value="value"
                      v-model="acctNoSfxMapForm.acctNoSfxApplnInt"
                      :error-messages="errors.collect('acctNoSfxApplnInt')"
                      data-vv-name="acctNoSfxApplnInt"
                      :data-vv-as="labels.acctNoSfxApplnInt"
                      v-validate="'required|max:10'"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs6>
                    <v-autocomplete
                      :label="labels.directRi"
                      :items="driList"
                      item-text="label"
                      item-value="value"
                      v-model="acctNoSfxMapForm.directRi"
                      :error-messages="errors.collect('directRi')"
                      data-vv-name="directRi"
                      :data-vv-as="labels.directRi"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </template>
              <template v-else>
                <v-layout row>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">{{ labels.acctNoSfxApplnInt }}</v-subheader>
                    <div class="queryValue">{{ getApplnInt(acctNoSfxMapForm.acctNoSfxApplnInt) }}</div>
                  </v-flex>
                  <v-flex xs6 v-if="!newMap">
                    <v-subheader class="queryLabel">{{ labels.directRi }}</v-subheader>
                    <div class="queryValue">{{ getDri(acctNoSfxMapForm.directRi) }}</div>
                  </v-flex>
                </v-layout>
              </template>
              <v-spacer class="mt-2"></v-spacer>
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                  <div class="queryValue">{{ acctNoSfxMapForm.createdBy }}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                  <div class="queryValue">{{ acctNoSfxMapForm.createdDate | formatDate }}</div>
                </v-flex>
              </v-layout>
              <v-layout wrap v-if="!newMap">
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                  <div class="queryValue">{{ acctNoSfxMapForm.modifiedBy }}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                  <div class="queryValue">{{ acctNoSfxMapForm.modifiedDate | formatDate }}</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red darken-1" @click.native="doClose">Cancel</v-btn>
            <v-btn text color="primary" @click.native="doSave" v-if="newMap">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <confirm ref="confirmDelete">
        <p>
          Are you sure you want to delete the selected record? ({{ selectedMap.applnIntDesc }}, {{ selectedMap.acctNoSfx }},
          {{ selectedMap.directRiDesc }})
        </p>
      </confirm>
    </v-flex>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import { acctNoSfxApplnInt } from '@/const/acct'
export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Application Interface', value: 'applnIntDesc' },
        { text: 'Account No. Suffix', value: 'acctNoSfx' },
        { text: 'Direct / RI Inwards', value: 'directRiDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        acctNoSfxApplnInt: 'Application Interface',
        applnIntDesc: 'Application Interface',
        acctNoSfx: 'Account No. Suffix',
        directRi: 'Direct / RI Inwards',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      acctNoSfxMapForm: {
        acctNoSfxApplnInt: null,
        acctNoSfx: null,
        directRi: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      filters: {
        acctNoSfxApplnInt: undefined,
        acctNoSfx: this.acctNoSfx,
        directRi: undefined,
        applnIntDesc: undefined
      },
      totalItems: 0,
      applnIntList: null,
      mapDialog: false,
      newMap: false,
      selectedMap: {
        acctNoSfxApplnInt: null,
        applnIntDesc: null,
        acctNoSfx: null,
        directRi: null,
        directRiDesc: null
      },
      directRiList: [
        { code: 'D', value: 'Direct' },
        { code: 'R', value: 'RI Inwards' }
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.getApplnIntList()
    this.fetchData(true)
  },
  methods: {
    getApplnIntList() {
      const apiURI = this.menu.getApplnIntList
      if (apiURI) {
        this.$http
          .get(apiURI)
          .then((result) => {
            const { data } = result.data
            this.applnIntList = data
          })
          .catch((err) => {
            this.applnIntList = []
          })
      }
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getAcctNoSfxMapList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((map) => {
                const convertList = {
                  acctNoSfxApplnInt: map.acctNoSfxApplnInt,
                  applnIntDesc: map.applnIntDesc,
                  acctNoSfx: map.acctNoSfx,
                  directRi: map.directRi,
                  directRiDesc: this.getDri(map.directRi)
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doNew() {
      this.resetMessages()
      this.newMap = true
      this.mapDialog = true
      this.acctNoSfxMapForm.acctNoSfx = this.acctNoSfx
      this.acctNoSfxMapForm.acctNoSfxApplnInt = null
      this.acctNoSfxMapForm.directRi = ''
      this.acctNoSfxMapForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.acctNoSfxMapForm.createdDate = new Date()
    },
    doQuery(data) {
      this.resetMessages()
      if (data) {
        const apiURI = this.menu.getAcctNoSfxMap
        if (apiURI) {
          const expand = {
            acctNoSfxApplnInt: data.acctNoSfxApplnInt,
            acctNoSfx: data.acctNoSfx,
            directRi: data.directRi
          }
          this.$http
            .get(expandURI(apiURI, expand))
            .then((result) => {
              const { data } = result.data
              if (data) {
                this.acctNoSfxMapForm.acctNoSfxApplnInt = data.acctNoSfxMap.acctNoSfxApplnInt
                this.acctNoSfxMapForm.acctNoSfx = data.acctNoSfxMap.acctNoSfx
                this.acctNoSfxMapForm.directRi = data.acctNoSfxMap.directRi
                this.acctNoSfxMapForm.createdBy = data.createdBy
                this.acctNoSfxMapForm.createdDate = data.createdDate
                this.acctNoSfxMapForm.modifiedBy = data.modifiedBy
                this.acctNoSfxMapForm.modifiedDate = data.modifiedDate
              }
              this.newMap = false
              this.mapDialog = true
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          const apiURI = this.menu.createAcctNoSfxMap
          if (apiURI) {
            this.$http
              .post(apiURI, this.acctNoSfxMapForm)
              .then((result) => {
                const { data } = result
                this.notify(data)
                this.fetchData(true)
                this.doClose()
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doDelete(data) {
      this.resetMessages()
      const apiURI = this.menu.deleteAcctNoSfxMap
      if (data && apiURI) {
        this.selectedMap.acctNoSfxApplnInt = data.acctNoSfxApplnInt
        this.selectedMap.applnIntDesc = data.applnIntDesc
        this.selectedMap.acctNoSfx = data.acctNoSfx
        this.selectedMap.directRi = data.directRi ? data.directRi : ''
        this.selectedMap.directRiDesc = data.directRiDesc
        this.$refs.confirmDelete.doPopUp().then((result) => {
          if (result) {
            this.$http
              .post(apiURI, this.selectedMap)
              .then((result) => {
                const { data } = result
                this.notify(data)
                this.fetchData(true)
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        })
      }
    },
    doClose() {
      this.resetMessages()
      this.mapDialog = false
      this.newMap = false
    },
    getApplnInt(value) {
      return acctNoSfxApplnInt[value]
    },
    getDri(value) {
      return this.dri[value]
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.applnIntDesc = undefined
      this.filters.directRi = undefined
      this.pagination.page = 1
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    }
  },
  computed: {
    menu() {
      return this.$store.state.acctNoSfxParam.menu
    },
    driList() {
      const dri = this.dri
      let result = [{ label: '(Blank)', value: '' }]
      Object.keys(dri).forEach((key) => {
        const status = dri[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    dri() {
      return {
        D: 'Direct',
        R: 'RI Inwards'
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  filters: {
    formatDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return null
      }
    }
  },
  mixins: [TableConst.default, MessageMixin],
  props: ['acctNoSfx']
}
</script>

<style>
</style>
